import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import './styles.css';

class Accounts extends Component {
  constructor(props){
    super(props);
    this.state = {
      linkedin: (this.props.accounts && this.props.accounts.linkedin) ? this.props.accounts.linkedin : 'https://',
      stackoverflow: (this.props.accounts && this.props.accounts.stackoverflow) ? this.props.accounts.stackoverflow : 'https://',
      github: (this.props.accounts && this.props.accounts.github) ? this.props.accounts.github : 'https://',
      'social media': (this.props.accounts && this.props.accounts['social media']) ? this.props.accounts['social media'] : 'https://',
      'own website': (this.props.accounts && this.props.accounts.xing) ? this.props.accounts['own website'] : 'https://',
    }
  }

  componentDidMount() {
    this.triggerOnChange = debounce(this.triggerOnChange, 500);
  }

  updateByKey(name, value){
    this.setState({[name]: value});
    this.triggerOnChange();
  }

  triggerOnChange(){
    if(this.props.onChange){
      this.props.onChange.call(null, this.state);
    }
  }

  renderLine(index, key){
    return (
      <div className="form-controls-row" key={index}>
        <div className="form-control-cell">
          <label>{key}</label>
          <input value={this.state[key]} onChange={(e) => {this.updateByKey(key, e.target.value)}} type="text"/>
        </div>
      </div>
    );
  }

  render(){
    return (
      <div>
        {Object.keys(this.state).map((item, key) => {
          return this.renderLine(key, item)
        })}
      </div>
    );
  }
}

export default Accounts;



// WEBPACK FOOTER //
// ./src/components/Accounts/Accounts.js